import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'detailsAttestation', en);
i18next.addResources('fr', 'detailsAttestation', fr);

declare global {
  interface RegisteredLocales {
    detailsAttestation: typeof en;
  }
}
